import { RenderChipProps } from '@/components/core/Games/LastRounds/Chips/props';
import Link from '@/components/core/Link';
import { platformAssets } from '@/utils/assets';
import { Image } from '@starsoft/common/components';
import styles from './styles.module.scss';

export default function DoubleLastRoundsChip({
  round,
  isLoading,
  cover,
  modal,
  link,
}: RenderChipProps) {
  if (isLoading) {
    return (
      <div
        className={`${styles.skeleton} ${cover ? styles['skeleton--cover'] : ''}`}
      />
    );
  }

  if (round?.roulette?.tile?.multiplier?.toNumber() === 14) {
    return (
      <Link
        className={`${styles.link} ${styles[`link--${round?.roulette?.tile?.type?.color}`]} ${cover ? styles['link--cover'] : ''}`}
        href={link}
        modal={modal}
      >
        <Image
          className={styles.link__image}
          width={32}
          height={32}
          src={platformAssets.logo.icon}
          alt="logo"
          secondarySkeleton
        />
      </Link>
    );
  }

  return (
    <Link
      className={`${styles.link}  ${cover ? styles['link--cover'] : ''}`}
      href={link}
      modal={modal}
      style={{
        backgroundColor: round?.roulette?.tile?.type?.color,
      }}
    >
      <div className={styles.link__circle}>
        {round?.roulette?.tile?.multiplier?.toNumberString()}
      </div>
    </Link>
  );
}
